module.exports = __webpack_public_path__ + "static/logo-white-ios-27c7cb98ddad0e9449704dd0f938264a.svg";